"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var QuestionCircle = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M12 8a2.001 2.001 0 0 0-2 2v1H8v-1a3.995 3.995 0 0 1 4-4 4 4 0 0 1 4 4c0 .91-.23 1.66-.782 2.18-.517.488-1.16.616-1.554.681-.116.02-.2.032-.272.043-.088.013-.16.023-.257.041-.058.011-.102.022-.135.03V14h-2v-1c0-.372.07-.744.262-1.079.198-.344.479-.566.76-.706a2.81 2.81 0 0 1 .742-.235c.115-.021.275-.046.405-.065l.167-.026c.356-.06.463-.12.509-.163.014-.013.155-.145.155-.726a2 2 0 0 0-2-2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", fill: fill || 'currentColor' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16z", fill: fill || 'currentColor' })));
};
exports.default = QuestionCircle;
